import Http from './Http';
//import axiosCancel from 'axios-cancel';
var param= require('jquery-param');

export async function  getData(url,params) {
    const result= await Http.get(url,{params:params}); 
    if(!result){
        return {data:{
            data:[]
        }};
    }

    return result;
}

export async function viewData(url) {
    const result=  await Http.get(url,{params:{}});
    if(!result){
        return {data:{
            data:[]
        }};
    }
    return result;
}
  
export async function processData(url,data) {
    const result=  await Http.post(url,param(data));
    if(!result){
        return {data:{
            data:[]
        }};
    }
    return result;
    
}
 
export async function deleteData(url) {
    const result= await Http.delete(url,{params:{}});

    if(!result){
        return {data:{
            data:[]
        }};
    }
    return result;
    
}
  
export async function processFileData(url,data) {
    const result= await Http.post(url,data,{
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer '+localStorage.getItem('token')
        }
    });
    if(!result){
        return {data:{
            data:[]
        }};
    }
    return result;
}
 


// WEBPACK FOOTER //
// ./src/core/HttpAction.js